const initialState = {
    comparisonMarkets: [],
    isRightPanelVisible:false
}

export default (state = initialState, action) => {
    switch (action.type) {

        case "FETCH_MARKET_DETAILS":
            if (action.payload[0]) {
                const market = {
                    "greaterRegion": action.payload[0].greaterRegion,
                    "region": action.payload[0].region,
                    "market": action.payload[0].market,
                    "marketDetails": action.payload,
                }
                let comparisonMarkets = [...state.comparisonMarkets]
                comparisonMarkets[0] = market
                return {
                    ...state,
                    comparisonMarkets: comparisonMarkets
                }
            }
            return { ...state }
        case "FETCH_COMPARE_MARKET_DETAILS":
            if (action.payload[0]) {
                const compareMarket = {
                    "greaterRegion": action.payload[0].greaterRegion,
                    "region": action.payload[0].region,
                    "market": action.payload[0].market,
                    "marketDetails": action.payload,
                }
                const newComparisonMarkets = []
                newComparisonMarkets.push(state.comparisonMarkets[0])
                newComparisonMarkets.push(compareMarket)
                return {
                    ...state,
                    comparisonMarkets: [...newComparisonMarkets],
                    isRightPanelVisible:true
                }
            } return { ...state }

        case "RESET_MARKET_COMPARE_QUARTERS":
            return {
                ...state,
                comparisonMarkets: [state.comparisonMarkets[0]],
                isRightPanelVisible:false
            }
            case "CLEAR_COMPARISON_MARKET_SELECTED":
                return {
                    ...state,
                    isRightPanelVisible:false
                }
        default:
            return state
    }
}


function refineMarketData(market) {
    let marketDetails = JSON.parse(JSON.stringify(market))
    for (let index = 0; index < marketDetails.length; index++) {
        const element = marketDetails[index];
        delete element.greaterRegion
        delete element.region
        delete element.market
    }
    return marketDetails
}